import axios from 'axios';
import authHeader from "../../services/auth-header";
import ConstApiUrls from "../../services/const-api-urls";

const API_URL = ConstApiUrls.API_SERVICE_URL

class FSalesmanService {
    getApiUrl() {
        return API_URL
    }

    getAllFSalesman(){
        return axios.get(API_URL + `getAllFSalesman`, { headers: authHeader() });
    }
    getAllFSalesmanSimple(){
        return axios.get(API_URL + `getAllFSalesmanSimple`, { headers: authHeader() });
    }
    getAllFSalesmanContainingExt(fsalesmanFilter){
        return axios.post(API_URL + `getAllFSalesmanContainingExt`, fsalesmanFilter,{ headers: authHeader() });
    }
    getAllFSalesmanByDivision(fdivisionBean){
        return axios.get(API_URL + `getAllFSalesmanByDivision/${fdivisionBean}`, { headers: authHeader() });
    }
    getAllFSalesmanByCompany(){
        return axios.get(API_URL + `getAllFSalesman`, { headers: authHeader() });
    }
    getAllMyAgenChildrenAndMe(){
        return axios.get(API_URL + `getAllMyAgenChildrenAndMe`, { headers: authHeader() });
    }
    getAllFSalesmanContaining(page, pageSize, sortBy, order, search){
        // return axios.get(API_URL + `getAllFSalesman`, { headers: authHeaderMultipart() });
        return axios.get(API_URL + `getAllFSalesmanContaining?page=${page}&pageSize=${pageSize}&sortBy=${sortBy}&order=${order}&search=${search}`, { headers: authHeader() });
    }
    getFSalesmanById(id){
        return axios.get(API_URL + `getFSalesmanById/${id}`, { headers: authHeader() });
    }
    updateFSalesman(item){
        return axios.put(API_URL + `updateFSalesman/${item.id}`, item, {headers: authHeader()})
    }
    updateFSalesmanProfile(item){
        return axios.put(API_URL + `updateFSalesmanProfile/${item.id}`, item, {headers: authHeader()})
    }
    createFSalesman(item){
        // console.log(JSON.stringify(item));
        return axios.post(API_URL + `createFSalesman`, item, {headers: authHeader()})
    }
    deleteFSalesman(id){
        return axios.delete(API_URL + `deleteFSalesman/${id}`, {
            headers: authHeader()
        });
    }
    deleteAllFSalesman(itemIds){
        // let user = JSON.parse(localStorage.getItem('user'));
        // return axios.delete(API_URL + `deleteAllFSalesman`, {
        //     headers:  authHeaderMultipart(),
        //     data: {
        //         message: 'delete  success'
        //     }
        // });
        return axios.delete(API_URL + `deleteAllFSalesman`, {
            headers:  authHeader(),
            data: itemIds
        });


    }
}
export default new FSalesmanService()